import { PaymentProvider } from '../components/services/AuthServiceTypes';

export const getPaymentMethodType = (paymentMethod: PaymentProvider['paymentMethod']) => {
  switch (true) {
    case paymentMethod?.Type === 'BankTransfer' && paymentMethod.BankTransferType === 'SEPA':
      return 'sepa';
    case paymentMethod?.Type === 'CreditCard':
      return 'cc';
    case paymentMethod?.Type === 'PayPal':
      return 'paypal';
    case paymentMethod?.Type === 'ACH':
      return 'ach';
    case paymentMethod?.Type === 'Other':
      return 'invoice';
    default:
      return '';
  }
};
